/* eslint-disable @typescript-eslint/no-unsafe-member-access */
import { ActionContext, Module } from 'vuex';
import store from '@/store';

import type RootStateType from '@/store/types';
import generateMutations, { UPDATE_STATE_TYPE } from '@/store/generate-mutations';
import { getGalileoAb } from '@/shared/galileoAb';
import { ubtSendError } from '@/shared/utils/ubt';
import ProductCommodity from '@/shared/commodity';
import { ChannelDisableEnum } from '@/api/apply-product/types';
import type { MarketingAmountStateType } from './types';

const moduleStore: Module<MarketingAmountStateType, RootStateType> = {
  state: {
    /** 营销系数 用于计算展示潜力额度 */
    marketingCoefficient: null,
  },

  getters: {
    /** 是否是营销额度实验，条件为营销系数大于0且当前渠道支持营销额度 */
    isMarketingAmountExperiment(state: MarketingAmountStateType): boolean {
      const { channel } = store.state.applyProduct;
      return state.marketingCoefficient !== null
        && state.marketingCoefficient > 0
        && Boolean(channel?.supportMarketingAmount);
    },
  },

  actions: {
    /**
     * 伽利略实验：https://ab.hellobike.cn/experiment/detail/202507021722393087?labGuid=202211211841286660&isDetail=true
     * 实验名称：促提现营销潜力额度
     * 实验目的：测试促提现营销潜力额度实验分流结果
     */
    async getMarketingCoefficientABRes(
      context: ActionContext<MarketingAmountStateType, RootStateType>,
    ) {
      const { channelList, channel } = store.state.applyProduct;

      // 有自营渠道可提现
      const hasAutarkyAvailable = channelList.some(
        (item) => item.productId === ProductCommodity.AUTARKY_B_COMMODITY
        && item.disabled === ChannelDisableEnum.AVAILABLE,
      );

      /** 仅存在轻资产渠道可提现，未设置过营销系数，且当前渠道支持营销额度，则获取营销系数 */
      if (!hasAutarkyAvailable
        && context.state.marketingCoefficient === null
        && channel?.disabled === ChannelDisableEnum.AVAILABLE
        && channel?.supportMarketingAmount) {
        const { result } = await getGalileoAb().getAbResCatchError('202507021722393087', '202507021722393160');
        if (result && !Number.isNaN(Number(result))) {
          context.dispatch(UPDATE_STATE_TYPE, {
            marketingCoefficient: Number(result),
          });
        } else {
          ubtSendError(`The marketing coefficient experiment results are abnormal. result: ${result}`);
        }
      }
    },
  },
};

export default generateMutations(moduleStore);
